import CalendarSurfaceStore from '../store/schema/CalendarSurfaceStore';
import convertAllDayLayoutPositionToStyles from '../utils/convertAllDayLayoutPositionToStyles';
import getBaseTimeZone from '../utils/getBaseTimeZone';
import { CalendarSurfaceItemsConfig } from '../interfaces/CalendarItemsConfig';
import { ColumnProvider } from '../interfaces/ColumnProvider';
import { getHorizontalLayout } from '../logic/getHorizontalLayout';
import { SurfaceConstants } from 'owa-calendar-surface-core';
import { SurfaceItem } from '../interfaces/SurfaceItem';
import { SurfaceItemState } from '../interfaces/SurfaceItemState';
import { wrapToGridItem } from '../surfaceItems/GridItem';

/**
 * Transforms the specified all day surface item into one its corresponding JSX element
 * @param store The surface store
 * @param columnProvider the column Provider
 * @param itemsConfigTable the item's configuration table
 * @param item The surface item
 * @param rowIndex The row index for positioning the item
 * @returns The JSX element for the all day item
 */
export function transformAllDayItem(
    store: CalendarSurfaceStore,
    columnProvider: ColumnProvider,
    itemConfig: CalendarSurfaceItemsConfig,
    item: SurfaceItem,
    rowIndex: number = 0
): JSX.Element {
    let layout = {
        ...getHorizontalLayout(item, columnProvider, store.dayLength, store.userOptions.isRTL),
        top: rowIndex * SurfaceConstants.AllDayRowHeight,
        height: SurfaceConstants.AllDayRowHeight - 1, // leave 1px space between every item
    };

    let itemState: SurfaceItemState = {
        continuesLeft: item.clippedLeft,
        continuesRight: item.clippedRight,
        timeZoneId: getBaseTimeZone(store.timeZoneIds),
    };

    return wrapToGridItem(
        {
            ...convertAllDayLayoutPositionToStyles(layout),
            marginRight: item.clippedRight ? 0 : 12,
        },
        item.key,
        itemConfig,
        item.model,
        itemConfig && itemConfig.template && itemConfig.template(store, item.model, itemState),
        0 /* item index */,
        item.key /* tab Id */
    );
}
